import {
    ChartShapeInfoConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/common/chart-shape-info-converter';
import {
    ChartLayoutConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/common/chart-layout-converter';
import type { DeepPartial, DeepReadonly } from 'ts-essentials';
import type {
    IChartPlotArea,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import type { IPlotArea, DeltaOf } from '@tencent/slide-sdk-model';
import type { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

export class ChartPlotAreaConverter {
    public static convertPartialDataSdkToUi(
        sdkData: DeepReadonly<DeepPartial<IPlotArea>>,
        uiData: IChartPlotArea,
    ) {
        ChartShapeInfoConverter.convertPartialDataFromSdkToUi(sdkData, uiData as unknown as IShapeModel);

        // 绘图区布局
        if (sdkData.layout !== undefined) {
            uiData.layout = uiData.layout || {};
            ChartLayoutConverter.convertPartialDataFromSdkToUi(sdkData.layout, uiData.layout);
        }
    }

    public static convertPartialDataUiToSdk(
        uiData: DeepPartial<IChartPlotArea>,
        sdkData: DeltaOf<IPlotArea>,
    ) {
        // 标题默认文本属性、图形样式
        ChartShapeInfoConverter.convertPartialDataFromUiToSdk(uiData as IShapeModel, sdkData);

        // 绘图区布局
        if (uiData.layout !== undefined) {
            if (!uiData.layout) {
                sdkData.layout = null;
            } else {
                sdkData.layout = sdkData.layout ?? {};
                ChartLayoutConverter.convertPartialDataFromUiToSdk(uiData.layout, sdkData.layout);
            }
        }
    }
}
